import { useState, useEffect } from 'react';
import heroPoster from "../assets/images/farm2.jpg";
const heroVideoCombined = require("../assets/videos/farm-hero-combined.mp4"); // Se você criar

function Hero() {
  const [loaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [connectionSpeed, setConnectionSpeed] = useState('fast');

  useEffect(() => {
    // Detecta dispositivo mobile
    setIsMobile(window.innerWidth < 768);
    
    // Detecta velocidade de conexão (se disponível)
    try {
      const nav = navigator as any;
      const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
      if (connection && connection.effectiveType) {
        const speed = connection.effectiveType;
        setConnectionSpeed(speed === 'slow-2g' || speed === '2g' ? 'slow' : 'fast');
      }
    } catch (error) {
      setConnectionSpeed('fast');
    }
  }, []);

  const shouldShowVideo = connectionSpeed === 'fast' || !isMobile;

  return (
    <div id="hero" className="relative w-full h-screen drop-shadow-xl z-[4] overflow-hidden bg-white">
      {/* Fundo branco sempre visível */}
      <div className="absolute inset-0 bg-white" />
      
      {/* Imagem de fallback (só aparece se não for mostrar vídeo) */}
      {!shouldShowVideo && (
        <img
          src={heroPoster}
          className={`w-full h-full object-cover transition-opacity duration-500 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
          alt="Fazenda sustentável"
          loading="eager"
          onLoad={() => setLoaded(true)}
        />
      )}
      
      {/* Vídeo combinado em loop */}
      {shouldShowVideo && (
        <video
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onCanPlay={() => setLoaded(true)}
          onLoadedData={() => setLoaded(true)}
          poster={heroPoster}
        >
          <source src={heroVideoCombined} type="video/mp4" />
        </video>
      )}
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/20" />
      
      {/* Conteúdo */}
      <div className="absolute inset-0 flex flex-col items-center justify-end -translate-y-10 text-white text-center">
        <h2 className="sm:text-base sm:px-10 text-xl font-medium max-w-[43.75rem] pb-[10.7rem] drop-shadow-lg">
          Comprometidos com a qualidade e o meio ambiente, comercializamos alimentos que respeitam a natureza e nutrem a vida. Nosso beneficiamento garante produtos frescos e cultivados de forma sustentável, preservando o solo e os recursos naturais para as futuras gerações. Do Campo à sua mesa, levamos saúde e sabor com responsabilidade ambiental.
        </h2>
      </div>
      
      {/* Status indicator (removível em produção) */}
      {process.env.NODE_ENV === 'development' && (
        <div className="absolute top-4 left-4 text-xs text-white bg-black/50 px-2 py-1 rounded">
          {isMobile ? 'Mobile' : 'Desktop'} | {connectionSpeed} | Combined Video Loop
        </div>
      )}
    </div>
  );
}

export default Hero;